import React from 'react'
import GoHomeButton from '../../3_templates/Button/Types/GoHome'

const FourZeroFour = props => {
	return (
		<div>
			<GoHomeButton />
			<h1>Page not found</h1>
		</div>
	)
}

export default FourZeroFour
